var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalStat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 60,
    viewBox: "0 0 64 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 30V37C0 49.7025 10.2974 60 23 60H31.9508H40.9016C53.6041 60 63.9016 49.7025 63.9016 37V30.0148C63.9016 30.0099 63.9016 30.0049 63.9016 30C63.9016 29.9951 63.9016 29.9901 63.9016 29.9852V23C63.9016 10.2975 53.6041 0 40.9016 0H31.9508H23C10.2974 0 0 10.2975 0 23V30Z",
    fill: "#FF9066"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.78,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4928 23.8068C30.514 23.5474 30.7308 23.3477 30.9911 23.3477H31.5009C31.7565 23.3477 31.971 23.5405 31.9981 23.7947L32.6605 30.0143L37.367 32.5396C37.5293 32.6266 37.6306 32.7959 37.6306 32.9801V33.3702C37.6306 33.6966 37.3228 33.9355 37.0065 33.8545L30.2291 32.119C29.9931 32.0585 29.8349 31.8367 29.8548 31.5938L30.4928 23.8068Z",
    fill: "#FF9066"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.901274,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1765 14.9594C23.9035 14.6539 23.3806 14.7663 23.2827 15.1514L21.5295 22.053C21.449 22.3697 21.7188 22.6725 22.0651 22.6541L29.6264 22.2518C30.0482 22.2293 30.258 21.7646 29.9846 21.4586L28.0433 19.2864C29.284 18.8883 30.5996 18.6804 31.9504 18.6804C38.6167 18.6804 44.0207 23.7545 44.0207 30.0137C44.0207 36.2729 38.6167 41.3471 31.9504 41.3471C25.2842 41.3471 19.8801 36.2729 19.8801 30.0137C19.8801 28.963 20.0317 27.9338 20.3272 26.9447L17.5926 26.2245C17.2326 27.4296 17.04 28.7006 17.04 30.0137C17.04 37.7457 23.7156 44.0137 31.9504 44.0137C40.1852 44.0137 46.8608 37.7457 46.8608 30.0137C46.8608 22.2817 40.1852 16.0137 31.9504 16.0137C29.879 16.0137 27.9063 16.4103 26.1136 17.1271L24.1765 14.9594Z",
    fill: "#FF9066"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalStat);
export default __webpack_public_path__ + "static/media/totalStat.0b431fa4f291addf303fa2bbf7c2d567.svg";
export { ForwardRef as ReactComponent };